<template>
  <page title="Magazine / Coupons">
    <div slot="page-header-right">
      <router-link to="/magazine/coupons/create">
        <button class="button is-primary">
          <b-icon icon="plus"></b-icon>
          <span>
            <slot>Add Coupons</slot>
          </span>
        </button>
      </router-link>
    </div>
    <div class="box">
      <b-table
        :data="coupons.data"
        :loading="coupons.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :current-page="coupons.current_page"
        :per-page="coupons.per_page"
        :total="coupons.total"
        @page-change="page => coupons.changePage(page)"
        backend-sorting
        @sort="(field, direction) => coupons.sort(field, direction)"
        :default-sort="['id', 'desc']"
        class="is-middle"
      >
        <template slot-scope="props">
          <b-table-column field="id" label="#" sortable width="80">
            <router-link
              class="has-text-dark"
              :to="'/magazine/coupons/' + props.row.id"
              >{{ props.row.id }}
            </router-link>
          </b-table-column>

          <b-table-column label="Code">
            <router-link
              :to="'/magazine/coupons/' + props.row.id"
              >
                {{ props.row.code }}
            </router-link>
          </b-table-column>

          <b-table-column label="Type">{{ props.row.type }}</b-table-column>

          <b-table-column label="Usage Type">{{ props.row.usage_type }}</b-table-column>

          <b-table-column label="Expiry Date">{{ props.row.expiry_date }}</b-table-column>

          <b-table-column label="Uses Count" centered>{{ props.row.uses_count }}</b-table-column>

          <b-table-column label="Created">{{ props.row.created_at }}</b-table-column>

          <b-table-column label="Function">
            <b-button
              type="is-danger"
              icon-right="delete"
              @click="destroy(props.row.id)">
            </b-button>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      coupons: new window.PaginatedRemoteCollection("/admin/api/coupons").load()
    };
  },

  methods: {
    destroy(id) {
      this.$buefy.dialog.confirm({
        title: "Deleting magazine?",
        message: "Warning the deleted data wouldn't restore.",
        cancelText: "Cancel",
        confirmText: "Delete magazine",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$http
            .delete('/admin/api/coupons/' + id)
            .then(() => {
              this.$buefy.toast.open("Coupon deleted.");

              this.load();
            })
            .catch(error => {
              new window.FailedResponseHandler(error).handle();
            });
        }
      });
    },
  }
};
</script>
